
      import { createLanguage, createTranslationFile } from '@vocab/webpack/web';
      
    const translations = createTranslationFile({
      "en": createLanguage(
        require.resolveWeak("./translations.json-en-virtual.json!=!../../../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJlbXBsb3llciI6ImVtcGxveWVyIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-translations" */
          "./translations.json-en-virtual.json!=!../../../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJlbXBsb3llciI6ImVtcGxveWVyIn0%3D!"
        )
      ),
"th": createLanguage(
        require.resolveWeak("./translations.json-th-virtual.json!=!../../../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJlbXBsb3llciI6IuC4nOC4ueC5ieC4m%2BC4o%2BC4sOC4geC4reC4muC4geC4suC4oyJ9!"),
        () => import(
          /* webpackChunkName: "th-translations" */
          "./translations.json-th-virtual.json!=!../../../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJlbXBsb3llciI6IuC4nOC4ueC5ieC4m%2BC4o%2BC4sOC4geC4reC4muC4geC4suC4oyJ9!"
        )
      ),
"id": createLanguage(
        require.resolveWeak("./translations.json-id-virtual.json!=!../../../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJlbXBsb3llciI6InBlcnVzYWhhYW4ifQ%3D%3D!"),
        () => import(
          /* webpackChunkName: "id-translations" */
          "./translations.json-id-virtual.json!=!../../../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJlbXBsb3llciI6InBlcnVzYWhhYW4ifQ%3D%3D!"
        )
      ),
"zh": createLanguage(
        require.resolveWeak("./translations.json-zh-virtual.json!=!../../../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJlbXBsb3llciI6IuWDseS4uyJ9!"),
        () => import(
          /* webpackChunkName: "zh-translations" */
          "./translations.json-zh-virtual.json!=!../../../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJlbXBsb3llciI6IuWDseS4uyJ9!"
        )
      ),
"en-AU": createLanguage(
        require.resolveWeak("./translations.json-en-AU-virtual.json!=!../../../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJlbXBsb3llciI6ImVtcGxveWVyIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-AU-translations" */
          "./translations.json-en-AU-virtual.json!=!../../../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJlbXBsb3llciI6ImVtcGxveWVyIn0%3D!"
        )
      ),
"en-HK": createLanguage(
        require.resolveWeak("./translations.json-en-HK-virtual.json!=!../../../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJlbXBsb3llciI6ImVtcGxveWVyIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-HK-translations" */
          "./translations.json-en-HK-virtual.json!=!../../../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJlbXBsb3llciI6ImVtcGxveWVyIn0%3D!"
        )
      ),
"en-ID": createLanguage(
        require.resolveWeak("./translations.json-en-ID-virtual.json!=!../../../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJlbXBsb3llciI6ImVtcGxveWVyIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-ID-translations" */
          "./translations.json-en-ID-virtual.json!=!../../../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJlbXBsb3llciI6ImVtcGxveWVyIn0%3D!"
        )
      ),
"en-MY": createLanguage(
        require.resolveWeak("./translations.json-en-MY-virtual.json!=!../../../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJlbXBsb3llciI6ImVtcGxveWVyIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-MY-translations" */
          "./translations.json-en-MY-virtual.json!=!../../../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJlbXBsb3llciI6ImVtcGxveWVyIn0%3D!"
        )
      ),
"en-NZ": createLanguage(
        require.resolveWeak("./translations.json-en-NZ-virtual.json!=!../../../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJlbXBsb3llciI6ImVtcGxveWVyIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-NZ-translations" */
          "./translations.json-en-NZ-virtual.json!=!../../../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJlbXBsb3llciI6ImVtcGxveWVyIn0%3D!"
        )
      ),
"en-PH": createLanguage(
        require.resolveWeak("./translations.json-en-PH-virtual.json!=!../../../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJlbXBsb3llciI6ImVtcGxveWVyIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-PH-translations" */
          "./translations.json-en-PH-virtual.json!=!../../../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJlbXBsb3llciI6ImVtcGxveWVyIn0%3D!"
        )
      ),
"en-SG": createLanguage(
        require.resolveWeak("./translations.json-en-SG-virtual.json!=!../../../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJlbXBsb3llciI6ImVtcGxveWVyIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-SG-translations" */
          "./translations.json-en-SG-virtual.json!=!../../../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJlbXBsb3llciI6ImVtcGxveWVyIn0%3D!"
        )
      ),
"en-TH": createLanguage(
        require.resolveWeak("./translations.json-en-TH-virtual.json!=!../../../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJlbXBsb3llciI6ImVtcGxveWVyIn0%3D!"),
        () => import(
          /* webpackChunkName: "en-TH-translations" */
          "./translations.json-en-TH-virtual.json!=!../../../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJlbXBsb3llciI6ImVtcGxveWVyIn0%3D!"
        )
      ),
"th-TH": createLanguage(
        require.resolveWeak("./translations.json-th-TH-virtual.json!=!../../../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJlbXBsb3llciI6IuC4nOC4ueC5ieC4m%2BC4o%2BC4sOC4geC4reC4muC4geC4suC4oyJ9!"),
        () => import(
          /* webpackChunkName: "th-TH-translations" */
          "./translations.json-th-TH-virtual.json!=!../../../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJlbXBsb3llciI6IuC4nOC4ueC5ieC4m%2BC4o%2BC4sOC4geC4reC4muC4geC4suC4oyJ9!"
        )
      ),
"id-ID": createLanguage(
        require.resolveWeak("./translations.json-id-ID-virtual.json!=!../../../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJlbXBsb3llciI6InBlcnVzYWhhYW4ifQ%3D%3D!"),
        () => import(
          /* webpackChunkName: "id-ID-translations" */
          "./translations.json-id-ID-virtual.json!=!../../../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJlbXBsb3llciI6InBlcnVzYWhhYW4ifQ%3D%3D!"
        )
      ),
"zh-HK": createLanguage(
        require.resolveWeak("./translations.json-zh-HK-virtual.json!=!../../../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJlbXBsb3llciI6IuWDseS4uyJ9!"),
        () => import(
          /* webpackChunkName: "zh-HK-translations" */
          "./translations.json-zh-HK-virtual.json!=!../../../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJlbXBsb3llciI6IuWDseS4uyJ9!"
        )
      ),
"en-PSEUDO": createLanguage(
        require.resolveWeak("./translations.json-en-PSEUDO-virtual.json!=!../../../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJlbXBsb3llciI6Ilvhur3hur1tzILGpcaaw7bDtsO9w73hur3hur3FmV0ifQ%3D%3D!"),
        () => import(
          /* webpackChunkName: "en-PSEUDO-translations" */
          "./translations.json-en-PSEUDO-virtual.json!=!../../../../../../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?source=eyJlbXBsb3llciI6Ilvhur3hur1tzILGpcaaw7bDtsO9w73hur3hur3FmV0ifQ%3D%3D!"
        )
      )
      });
  
      export { translations as default };
    